import React, { Component } from "react";
import { Redirect, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import api from "../../api.js";
import { AppContext } from "../../context/AppContext";

class LoginComponent extends Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      redirectToReferrer: false,
      redirectToLogin: false,
      error: null,
    };
  }

  async componentDidMount() {
    console.log("in login, is authenticated", api.authentication.authenticated);

    let userResults = null;

    const hash = this.props?.location?.hash;
    // Check if access_token has been included in URL hash - this will be supplied from Oauth redirect back to this page
    if (!hash) {
      // If it is not there - we need to redirect to Oauth login page
      console.log("Setting redirectToLogin");
      this.setState({ redirectToLogin: true });
      return;
    } else {
      // If it IS there, we can call our client authenticate() function to extract and store the tokens
      console.log("Access token received, calling authenticate to extract...");
      try {
        userResults = await api.authenticate();
        console.log("Done", userResults);
      } catch (err) {
        console.log("auth failed - ", err);
        console.log("Setting redirectToLogin");
        this.setState({ redirectToLogin: false, error: err });
        return;
      }
    }

    //console.log('auth results from login', userResults);
    let user = await api.service("users").get(userResults.user._id);
    console.log("got user record in login", user);
    this.context.onProfileChange(userResults.user);
    //this.context.updateUser(user);
    this.setState({ redirectToReferrer: true });
  }

  render() {
    const { redirectToReferrer, redirectToLogin } = this.state;
    //		const loginFormProps = { error: !_.isEmpty(errors) };

    const { from } = this.props.location.state || { from: { pathname: "/" } };

    if (redirectToReferrer) {
      console.log("Diverting from /auth to", from);
      return <Redirect to={from} />;
    }

    if (redirectToLogin) {
      console.log("Redirecting to OAuth login");
      window.location = `${window.env.API_URL}/oauth/keycloak`;
      return <div></div>;
    }

    if (this.state.error) {
      console.log("Error received");
      return (
        <div style={{ marginTop: "20px", width: "75%", marginLeft: 'auto', marginRight: 'auto', textAlign: 'center', border: '1px solid black' }}>
          <span>
            A <b>{this.state.error.name}</b> error occured during login:{" "}
            <b>{this.state.error.message}</b>.
          </span>
        </div>
      );
    }

    return (
      <div></div>
      //   <Container style={{ marginTop: '20px', width: '75%' }}>
      //     <Header textAlign='center'>Logging in, please wait...</Header>
      //   </Container>
    );
  }
}

LoginComponent.contextType = AppContext;

LoginComponent.propTypes = {
  login: PropTypes.func,
  errors: PropTypes.object,
};

export default withRouter(LoginComponent);
